import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foreground-code",
  "use": "foreground-code-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"foreground-code\"><g id=\"foreground-code_Layer_2\" data-name=\"Layer 2\"><g id=\"foreground-code_Layer_1-2\" data-name=\"Layer 1\"><path d=\"M20,4V0H0V20H4v4H24V4ZM2,18V2H18V18H2Zm20,4H6V20H20V6h2Z\" /><path d=\"M8,14.85h6.29l2.2-4.56L14.37,6l-.11-.23H8A4.51,4.51,0,0,0,6.61,6L6,6.22a4.63,4.63,0,0,0-2.55,4.07h0A4.61,4.61,0,0,0,8,14.85Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol